module.exports = __webpack_public_path__ + "media/fonts/Roboto-Bold-c13d0c4f45623629e371e242079abf1e.ttf";